import { routesFlat } from "@routes";

export default function getBgColor(
    currentRoute,
    scrollOpacity,
    isMobileOpen = false,
) {
    if (isMobileOpen) {
        return { backgroundColor: `rgb(70, 206, 132)` }; // bg-green
    }

    const isContentPage =
        currentRoute.includes(routesFlat.contact) ||
        currentRoute.includes(routesFlat.news);

    if (isContentPage) {
        return { backgroundColor: `rgb(70, 206, 132)` }; // bg-green
    }

    const translucentRoutes = [
        routesFlat.landing,
        routesFlat.activityData,
        routesFlat.treeLevel,
        routesFlat.landCarbon,
    ];

    if (translucentRoutes.includes(currentRoute)) {
        return { backgroundColor: `rgba(255, 255, 255, ${scrollOpacity})` };
    }

    return { backgroundColor: `rgba(255, 255, 255, ${Math.min(scrollOpacity + 0.2, 1)})` };
}
